import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { TourReactStep } from 'webapp/models-custom/tour-react';
import TourReactBase from 'webapp/models-custom/tour-react';

export default class GenieCustomizeTour extends TourReactBase {
	static keyForPersistantDone = UserSettingsKey.GENIE_CUSTOMIZE;

	get id(): string {
		return TourId.GENIE_CUSTOMIZE;
	}

	override get keyForPersistantDone(): string {
		return GenieCustomizeTour.keyForPersistantDone;
	}

	get steps(): TourReactStep[] {
		return [{ id: 'settings', anchorId: 'settings', side: 'top', align: 'end' }];
	}
}
